<template>
  <EditDialog
    v-model:visible="showModal"
    :title="
      $t('views.layout.components.MenuList.41a3bf0dfa2b3e08a2251e00378a7ec3')
    "
    :width="520"
    :mask-closable="false"
    :loading="loading"
    hide-footer
  >
    <div>
      <div class="user-avatar fc">
        <Avatar
          :url="avatar"
          :size="72"
          :editabled="!isCompanyUser"
          :img-list="imgList"
          @select="handleSelect"
        />
      </div>
      <div class="form">
        <div class="form-item-wrap">
          <span class="label">{{
            $t(
              'views.layout.components.MenuList.4640f58fde489e355a5fb0e8fe1d454c'
            )
          }}</span>
          <div class="form-item">
            <u-input v-model="nickName" readonly :maxlength="20" />
            <span
              v-if="!isCompanyUser"
              class="suff"
              @click="handleModifyNickName"
              >{{ $t('common.3b1c0e7488335a4f3b91a85979d0c296') }}</span
            >
          </div>
        </div>
        <div class="form-item-wrap">
          <span class="label">{{
            $t(
              'views.layout.components.MenuList.a68c54dcff68dc50bdc34f3ac250d554'
            )
          }}</span>
          <div class="form-item">
            <u-input v-model="email" readonly />
            <span
              v-if="!email && !isCompanyUser"
              class="suff"
              @click="handleEmail"
              >{{
                $t(
                  'views.layout.components.MenuList.0a375d1e486ee7b0f8cf31c02cdd1c9f'
                )
              }}</span
            >
          </div>
        </div>
        <div v-if="IS_DOMESTIC" class="form-item-wrap">
          <span class="label">{{
            $t(
              'views.layout.components.MenuList.ed1c5bc9fa7596ad4402dd2aa6ec9d8f'
            )
          }}</span>
          <div class="form-item">
            <u-input v-model="phone" readonly />
          </div>
        </div>
        <div class="form-item-wrap">
          <span class="label">{{
            $t(
              'views.layout.components.MenuList.1337cc83ba41fb4d4f4dd5cdeab2effc'
            )
          }}</span>
          <div class="form-password">
            <div v-for="i in 8" :key="i" class="circle" />
            <span class="suff" @click="handleModifyPw" data-testid="layout-dialog-accountsetting-modify-pw">{{
              $t('common.3b1c0e7488335a4f3b91a85979d0c296')
            }}</span>
          </div>
        </div>
        <div
          v-if="!isCompanyUser"
          class="cancellation"
          @click="handleCancellation"
        >
          {{
            $t(
              'views.layout.components.MenuList.853eca406af1410b13df080b3625181e'
            )
          }}
        </div>
      </div>
    </div>
    <ModifyCompanyPassword v-if="isCompanyUser" ref="modifyPassword" />
    <ModifyPassword v-else ref="modifyPassword" />
    <CancelAccount ref="cancelAccount" />
    <ModifyNickName ref="modifyNickName" />
    <BindEmail ref="bindEmail" />
  </EditDialog>
</template>

<script>
// import { useI18n } from 'vue-i18n';
import { defineComponent, ref, computed } from 'vue';

import { editUserInfoApi } from '@api/permission';
import { getAvatarApi } from '@/api/robot';
import { useStore } from 'vuex';
import ModifyPassword from './ModifyPassword.vue';
import ModifyCompanyPassword from './ModifyCompanyPassword.vue';
import CancelAccount from './CancelAccount.vue';
import ModifyNickName from './ModifyNickName.vue';
import BindEmail from './BindEmail.vue';

export default defineComponent({
  name: 'AccountSetting',
  components: {
    ModifyPassword,
    CancelAccount,
    ModifyNickName,
    BindEmail,
    ModifyCompanyPassword
  },
  setup() {
    // const { t } = useI18n();
    const store = useStore();
    const isCompanyUser = computed(() => store.getters.isCompanyUser);
    const showModal = ref(false);
    const loading = ref(false);
    const show = () => {
      showModal.value = true;
    };
    const avatar = computed(() => store.getters.botUserInfo?.avatar);
    const handleSelect = async url => {
      const res = await editUserInfoApi(
        {
          avatar: url
        },
        store.getters.botUserInfo.userId
      );
      if (res) {
        store.commit('setUserInfo', {
          ...store.state.app.botUserInfo,
          avatar: url
        });
      }
    };
    const imgList = ref([]);
    const getPersonAvatar = async () => {
      const res = await getAvatarApi({
        type: 'user'
      });
      imgList.value = res;
    };
    getPersonAvatar();
    const modifyPassword = ref(null);
    const cancelAccount = ref(null);
    const modifyNickName = ref(null);
    const bindEmail = ref(null);
    const handleModifyPw = () => {
      modifyPassword.value.show();
    };
    const closeAllDialog = () => {
      //   modifyPassword.value.show(false);
      //   cancelAccount.value.show(false);
    };
    const handleCancellation = () => {
      closeAllDialog();
      cancelAccount.value.show();
    };
    const handleEmail = () => {
      bindEmail.value.show(true);
    };
    const phone = store.getters.botUserInfo?.mobile;
    const email = store.getters.botUserInfo?.email;
    const nickName = computed(() => store.getters.botUserInfo?.nickname);

    const handleModifyNickName = () => {
      modifyNickName.value.show();
    };
    return {
      show,
      handleSelect,
      handleModifyPw,
      handleCancellation,
      imgList,
      phone,
      email,
      nickName,
      handleModifyNickName,
      avatar,
      loading,
      showModal,
      modifyNickName,
      modifyPassword,
      cancelAccount,
      isCompanyUser,
      bindEmail,
      handleEmail
    };
  }
});
</script>

<style lang="less" scoped>
.user-avatar {
  margin-top: 12px;
  margin-bottom: 45px;
  position: relative;

  cursor: pointer;
  .edit-avatar {
    color: var(--theme-color);
    position: absolute;
    bottom: 0;
    right: 0;
  }
}
.form {
  .form-item-wrap {
    width: 470px;
    margin-bottom: 28px;
    display: flex;
    align-items: center;
    .label {
      width: 96px;
      color: var(--font-color);
    }
  }
}
.form-item {
  position: relative;
  flex: 1;
}
.form-password {
  height: 40px;
  display: flex;
  align-items: center;
  width: 374px;
  border-radius: 8px;
  border: 1px solid var(--border-neutral-color-secondary);
  position: relative;
  padding-left: 16px;
  .circle {
    width: 6px;
    height: 6px;
    background: var(--active-font-color);
    border-radius: 50%;
    margin-right: 8px;
  }
}
.suff {
  position: absolute;
  right: 26px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--theme-color);
  cursor: pointer;
}
.cancellation {
  color: var(--theme-color);
  text-align: center;
  cursor: pointer;
}
</style>
